import { render, staticRenderFns } from "./specialTopicDetail.vue?vue&type=template&id=47213934&scoped=true&"
import script from "./specialTopicDetail.vue?vue&type=script&lang=js&"
export * from "./specialTopicDetail.vue?vue&type=script&lang=js&"
import style0 from "./specialTopicDetail.vue?vue&type=style&index=0&id=47213934&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47213934",
  null
  
)

export default component.exports